import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const BUSINESS_SECTORS = [
  {
    value: 'agency',
    label: 'Agence',
    subcategories: [
      { value: 'influence', label: 'Influence' },
      { value: 'pr', label: 'Relations Publiques' },
      { value: 'digital', label: 'Marketing Digital' },
      { value: 'creative', label: 'Créative' },
      { value: 'media', label: 'Média' },
      { value: 'event', label: 'Événementiel' },
      { value: 'communication', label: 'Communication' }
    ]
  },
  {
    value: 'family',
    label: 'Famille & Maternité',
    subcategories: [
      { value: 'maternity', label: 'Maternité' },
      { value: 'baby', label: 'Bébé' },
      { value: 'kids', label: 'Enfants' },
      { value: 'education', label: 'Éducation' },
      { value: 'parenting', label: 'Parentalité' }
    ]
  },
  {
    value: 'tech_apps',
    label: 'Tech & Applications',
    subcategories: [
      { value: 'mobile_apps', label: 'Applications Mobiles' },
      { value: 'saas', label: 'SaaS' },
      { value: 'fintech', label: 'FinTech' },
      { value: 'edtech', label: 'EdTech' },
      { value: 'iot', label: 'IoT' }
    ]
  },
  {
    value: 'gaming',
    label: 'Gaming & eSport',
    subcategories: [
      { value: 'video_games', label: 'Jeux Vidéo' },
      { value: 'esport', label: 'eSport' },
      { value: 'streaming', label: 'Streaming' },
      { value: 'gaming_hardware', label: 'Matériel Gaming' },
      { value: 'mobile_gaming', label: 'Gaming Mobile' }
    ]
  },
  {
    value: 'health',
    label: 'Santé & Bien-être',
    subcategories: [
      { value: 'medical', label: 'Médical' },
      { value: 'mental_health', label: 'Santé Mentale' },
      { value: 'nutrition', label: 'Nutrition' },
      { value: 'pharmacy', label: 'Pharmacie' },
      { value: 'wellness', label: 'Bien-être' }
    ]
  },
  {
    value: 'home',
    label: 'Maison & Décoration',
    subcategories: [
      { value: 'furniture', label: 'Mobilier' },
      { value: 'decoration', label: 'Décoration' },
      { value: 'garden', label: 'Jardin' },
      { value: 'diy', label: 'DIY' },
      { value: 'smart_home', label: 'Maison Connectée' }
    ]
  },
  {
    value: 'finance',
    label: 'Finance & Investissement',
    subcategories: [
      { value: 'banking', label: 'Banque' },
      { value: 'insurance', label: 'Assurance' },
      { value: 'investment', label: 'Investissement' },
      { value: 'crypto', label: 'Crypto-monnaies' },
      { value: 'personal_finance', label: 'Finance Personnelle' }
    ]
  },
  {
    value: 'fashion',
    label: 'Mode et Beauté',
    subcategories: [
      { value: 'ready_to_wear', label: 'Prêt-à-porter' },
      { value: 'accessories', label: 'Accessoires' },
      { value: 'cosmetics', label: 'Cosmétiques' },
      { value: 'perfumes', label: 'Parfumerie' },
      { value: 'jewelry', label: 'Bijoux' },
      { value: 'hair_care', label: 'Soins capillaires' }
    ]
  },
  {
    value: 'food',
    label: 'Alimentation et Boissons',
    subcategories: [
      { value: 'soft_drinks', label: 'Boissons gazeuses' },
      { value: 'alcoholic_beverages', label: 'Boissons alcoolisées' },
      { value: 'organic_food', label: 'Alimentation bio' },
      { value: 'snacks', label: 'Snacks et confiseries' },
      { value: 'dairy', label: 'Produits laitiers' }
    ]
  },
  {
    value: 'pet_food',
    label: 'Alimentation pour Animaux',
    subcategories: [
      { value: 'dry_food', label: 'Croquettes' },
      { value: 'wet_food', label: 'Nourriture humide' },
      { value: 'supplements', label: 'Compléments alimentaires' },
      { value: 'accessories', label: 'Accessoires pour animaux' },
      { value: 'care_products', label: 'Produits de soin' }
    ]
  },
  {
    value: 'tech',
    label: 'Tech et Digital',
    subcategories: [
      { value: 'software', label: 'Logiciels' },
      { value: 'mobile_apps', label: 'Applications mobiles' },
      { value: 'hardware', label: 'Matériel informatique' },
      { value: 'consumer_electronics', label: 'Électronique grand public' },
      { value: 'iot', label: 'Internet des objets (IoT)' },
      { value: 'ecommerce', label: 'E-commerce' }
    ]
  },
  {
    value: 'lifestyle',
    label: 'Lifestyle et Bien-être',
    subcategories: [
      { value: 'fitness', label: 'Fitness et musculation' },
      { value: 'meditation', label: 'Méditation et relaxation' },
      { value: 'healthy_food', label: 'Alimentation saine' },
      { value: 'sportswear', label: 'Vêtements de sport' },
      { value: 'yoga', label: 'Articles de yoga' },
      { value: 'mental_health', label: 'Santé mentale' }
    ]
  },
  {
    value: 'travel',
    label: 'Voyage et Tourisme',
    subcategories: [
      { value: 'travel_agencies', label: 'Agences de voyages' },
      { value: 'hotels', label: 'Hôtels et hébergement' },
      { value: 'transport', label: 'Transport (avion, train, voiture)' },
      { value: 'activities', label: 'Activités de loisirs et excursions' },
      { value: 'cruises', label: 'Croisières' }
    ]
  },
  {
    value: 'sport',
    label: 'Sport et Fitness',
    subcategories: [
      { value: 'equipment', label: 'Equipements sportifs' },
      { value: 'clothing', label: 'Vêtements de sport' },
      { value: 'nutrition', label: 'Nutrition sportive' },
      { value: 'accessories', label: 'Accessoires de fitness' },
      { value: 'clubs', label: 'Clubs de sport' }
    ]
  },
  {
    value: 'luxury',
    label: 'Luxe',
    subcategories: [
      { value: 'high_end_clothing', label: 'Vêtements haut de gamme' },
      { value: 'watches', label: 'Montres' },
      { value: 'cars', label: 'Voitures de luxe' },
      { value: 'jewelry', label: 'Joaillerie' },
      { value: 'accessories', label: 'Accessoires de luxe' },
      { value: 'perfumes', label: 'Parfumerie de luxe' }
    ]
  },
  {
    value: 'automotive',
    label: 'Automobile',
    subcategories: [
      { value: 'cars', label: 'Voitures' },
      { value: 'parts', label: 'Pièces et accessoires auto' },
      { value: 'insurance', label: 'Assurance automobile' },
      { value: 'rental', label: 'Location de véhicules' },
      { value: 'electric', label: 'Véhicules électriques' }
    ]
  },
  {
    value: 'entertainment',
    label: 'Divertissement',
    subcategories: [
      { value: 'movies', label: 'Films et séries' },
      { value: 'gaming', label: 'Jeux vidéo' },
      { value: 'music', label: 'Musique' },
      { value: 'theme_parks', label: 'Parcs d\'attractions' },
      { value: 'festivals', label: 'Festivals' }
    ]
  }
] as const;

export interface UserProfile {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  role?: string;
  agency_id?: string;
  user_role: 'admin' | 'user';
  permissions?: {
    collaborations: boolean;
    todo: boolean;
    clients: boolean;
    influencers: boolean;
    casting: boolean;
    accounting: boolean;
    resources: boolean;
    assistant: boolean;
    admin?: boolean;
    recruitment?: boolean;
  };
  created_at: string;
  updated_at?: string;
}

export interface Agency {
  id: string;
  name: string;
  owner_id: string;
  created_at: string;
  updated_at?: string;
}

export interface Todo {
  id: string;
  agency_id: string;
  user_id: string;
  assigned_to?: string;
  title: string;
  description?: string;
  status: 'pending' | 'in_progress' | 'completed';
  priority: 'low' | 'medium' | 'high';
  due_date?: string;
  completed_at?: string;
  created_at: string;
  updated_at: string;
}

export interface DailyBrief {
  id: string;
  agency_id: string;
  influencer_id: string;
  influencer_name: string;
  influencer_slug: string;
  agency_name: string;
  date: string;
  tasks: {
    id: string;
    text: string;
    completed: boolean;
    completed_at?: string;
  }[];
  internal_notes: string;
  created_at: string;
  updated_at: string;
}

export interface RecruitmentInfluencer {
  id: string;
  agency_id: string;
  full_name: string;
  username: string;
  instagram_url?: string;
  tiktok_url?: string;
  youtube_url?: string;
  internal_rating: number;
  tags: string[];
  collaborated_brands: string;
  status: 'spotted' | 'contacted' | 'validated' | 'refused';
  campaign_id?: string;
  created_at: string;
  updated_at: string;
}

export interface Contact {
  name: string;
  email: string;
  phone: string;
  type: 'brand' | 'agency';
  role?: string;
}

export interface Client {
  id: string;
  agency_id: string;
  brand_name: string;
  sector: {
    main: string;
    sub: string;
  };
  contacts: Contact[];
  notes: string;
  collabs_ids?: string[];
  created_at: string;
  updated_at: string;
}

export interface Platform {
  name: 'Instagram' | 'TikTok' | 'YouTube' | 'Twitch' | 'Snapchat';
  audience: string;
  handle: string;
}

export interface ContentRate {
  type: 'post_instagram' | 'story_instagram' | 'reel_instagram' | 'tiktok' | 'story_snapchat' | 'twitch' | 'youtube';
  price: string;
}

export interface Influencer {
  id: string;
  agency_id: string;
  agency_name?: string;

  // Basic info (used by both manual and scraped)
  full_name: string | null;
  display_name: string | null;
  username: string;

  // Compatibility fields (mapped from new structure)
  fullName?: string;
  phoneNumber?: string;
  birthDate?: string;
  internalReferent?: string;
  isExclusive?: boolean;
  publicToken?: string;
  publicLinkEnabled?: boolean;
  proposedTo?: string[];
  internalNotes?: string;

  // Manual management fields
  address: string;
  phone_number: string;
  birth_date: string;
  siret: string;
  platforms: Platform[];
  internal_referent: string;
  rates: ContentRate[];
  is_exclusive: boolean;
  public_token?: string;
  public_link_enabled?: boolean;
  proposed_to: string[];
  internal_notes: string;
  archived: boolean;
  is_manual: boolean;

  // Scraped data fields
  platform: string;
  followers_count: number;
  engagement_rate: number;
  profile_image_url: string | null;
  profile_url: string | null;
  bio: string | null;
  verified: boolean;
  avg_likes: number;
  avg_comments: number;
  posts_count: number;
  country: string | null;

  created_at: string;
  updated_at: string;
  collabs_count?: number;
}

// Helper function to normalize influencer data for backwards compatibility
export function normalizeInfluencer(influencer: any): Influencer {
  return {
    ...influencer,
    fullName: influencer.full_name || influencer.display_name || '',
    phoneNumber: influencer.phone_number || '',
    birthDate: influencer.birth_date || '',
    internalReferent: influencer.internal_referent || '',
    isExclusive: influencer.is_exclusive || false,
    publicToken: influencer.public_token || '',
    publicLinkEnabled: influencer.public_link_enabled || false,
    proposedTo: influencer.proposed_to || [],
    internalNotes: influencer.internal_notes || '',
    platforms: influencer.platforms || [],
    rates: influencer.rates || [],
  };
}

export interface Resource {
  id: string;
  agency_id?: string;
  agencyId?: string;
  name: string;
  type: 'brief' | 'contract' | 'invoice' | 'quote' | 'media_kit' | 'email' | 'training' | 'video' | 'other';
  description: string;
  url?: string;
  fileUrl?: string;
  fileName?: string;
  fileType?: string;
  fileSize?: number;
  file_url?: string;
  file_name?: string;
  file_type?: string;
  file_size?: number;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  created_at?: string;
  updated_at?: string;
}

export interface Deliverable {
  type: string;
  description: string;
  price: string;
}

export interface CollabInfluencer {
  id?: string;
  fullName: string;
  deliverables: Deliverable[];
  rate: string;
  creator_invoice_sent: boolean;
  paidPercentage?: number;
}

export interface Collab {
  id: string;
  agency_id: string;
  agency_name?: string;
  created_by?: string;
  name: string;
  date: string;
  brand: string;
  influencers: CollabInfluencer[];
  influencer_ids?: string[];
  quote_sent: boolean;
  quote_number?: string;
  contract_signed: boolean;
  manager: string;
  post_progress: '0' | '30' | '50' | '100';
  billing_status: string;
  invoice_number?: string;
  payment_received: boolean;
  type: 'collaboration_entrante' | 'collaboration_sortante' | 'casting_interne' | 'casting_externe';
  public_token?: string;
  public_link_enabled?: boolean;
  budget?: number;
  link_token?: string;
  link_active?: boolean;
  created_at: string;
  updated_at: string;
}

export interface TimelineItem {
  id: string;
  collab_id: string;
  influencer_id?: string;
  influencer_name?: string;
  step_name: string;
  deadline?: string;
  status: 'todo' | 'in_progress' | 'done' | 'late';
  order_index: number;
  created_at: string;
  updated_at: string;
}

export interface CollabDocument {
  id: string;
  collab_id: string;
  influencer_id?: string;
  influencer_name?: string;
  name: string;
  type: 'brief' | 'contract' | 'other';
  file_url: string;
  file_name: string;
  file_size: number;
  visible_for_brand: boolean;
  created_at: string;
  updated_at: string;
}

export interface CollabStats {
  id: string;
  collab_id: string;
  influencer_id?: string;
  influencer_name?: string;
  post_thumb?: string;
  post_url?: string;
  views: number;
  likes: number;
  engagement_rate: number;
  creator: string;
  created_at: string;
  updated_at: string;
}

export interface CastingBrief {
  id: string;
  agency_id: string;
  brand: string;
  name: string;
  description: string;
  requirements: string[];
  budget: string;
  start_date: string;
  end_date: string;
  status: 'draft' | 'active' | 'closed';
  selected_influencers: string[];
  proposed_influencers: {
    influencerId: string;
    fullName: string;
    status: 'pending' | 'accepted' | 'rejected';
    notes?: string;
    creativeNote?: string;
    references?: string[];
    brandComment?: string;
    brandStatus?: 'pending' | 'accepted' | 'maybe' | 'rejected';
    brandDecisionDate?: string;
  }[];
  public_token?: string;
  public_link_active?: boolean;
  deadline?: string;
  activity_log?: {
    id: string;
    action: string;
    user: string;
    timestamp: string;
    details?: string;
  }[];
  created_at: string;
  updated_at: string;
}

export async function getCurrentUser(): Promise<UserProfile | null> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', user.id)
    .maybeSingle();

  if (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }

  return data;
}

export async function signIn(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    if (error.message.includes('Invalid login credentials')) {
      throw new Error('Email ou mot de passe incorrect');
    }
    throw error;
  }

  return data;
}

export async function signUp(
  email: string,
  password: string,
  firstName: string,
  lastName: string,
  role: string,
  agencyName?: string,
  agencyCode?: string
) {
  // Appeler l'Edge Function pour créer l'utilisateur
  const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/signup-user`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
    },
    body: JSON.stringify({
      email,
      password,
      firstName,
      lastName,
      role,
      agencyName,
      agencyCode,
    }),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Erreur lors de l\'inscription');
  }

  // Maintenant se connecter avec les credentials créés
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    throw error;
  }

  return data;
}

export async function logout() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export async function deleteAccount(password: string) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user || !user.email) {
    throw new Error('Aucun utilisateur connecté');
  }

  const { error: signInError } = await supabase.auth.signInWithPassword({
    email: user.email,
    password,
  });

  if (signInError) {
    throw new Error('Mot de passe incorrect');
  }

  const { error: deleteError } = await supabase
    .from('users')
    .delete()
    .eq('id', user.id);

  if (deleteError) throw deleteError;

  const { error: authDeleteError } = await supabase.auth.admin.deleteUser(user.id);
  if (authDeleteError) throw authDeleteError;
}

export async function joinAgency(agencyCode: string) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    throw new Error('Aucun utilisateur connecté');
  }

  const { data: agencyCheck } = await supabase
    .from('agencies')
    .select('id')
    .eq('id', agencyCode)
    .maybeSingle();

  if (!agencyCheck) {
    throw new Error('Cette agence n\'existe pas');
  }

  // Les utilisateurs avec un email @swipe-upp.com n'ont pas besoin d'abonnement
  const isSwipeUppEmail = user.email?.endsWith('@swipe-upp.com');

  if (!isSwipeUppEmail) {
    const { data: subscription, error: subError } = await supabase
      .from('subscriptions')
      .select(`
        *,
        plan:subscription_plans(*)
      `)
      .eq('agency_id', agencyCode)
      .eq('status', 'active')
      .maybeSingle();

    if (subError) {
      console.error('Error checking subscription:', subError);
    }

    if (!subscription) {
      throw new Error('Cette agence n\'a pas d\'abonnement actif');
    }

    const { count: currentSeats } = await supabase
      .from('users')
      .select('*', { count: 'exact', head: true })
      .eq('agency_id', agencyCode);

    if (subscription.plan.seat_limit !== null && currentSeats !== null) {
      if (currentSeats >= subscription.plan.seat_limit) {
        throw new Error(`Cette agence a atteint sa limite de sièges (${currentSeats}/${subscription.plan.seat_limit} - plan ${subscription.plan.name}). Veuillez contacter l'administrateur de l'agence pour qu'il passe à un plan supérieur avant de pouvoir rejoindre l'équipe.`);
      }
    }
  }

  const { error } = await supabase
    .from('users')
    .update({
      agency_id: agencyCode,
      user_role: 'user',
      updated_at: new Date().toISOString(),
    })
    .eq('id', user.id);

  if (error) throw error;

  // Ne pas incrémenter seats_used pour les emails @swipe-upp.com
  if (!isSwipeUppEmail) {
    const { count: currentSeats } = await supabase
      .from('users')
      .select('*', { count: 'exact', head: true })
      .eq('agency_id', agencyCode);

    const { data: subscription } = await supabase
      .from('subscriptions')
      .select('id, seats_used')
      .eq('agency_id', agencyCode)
      .eq('status', 'active')
      .maybeSingle();

    if (subscription) {
      const newSeatsUsed = (currentSeats || 0);
      await supabase
        .from('subscriptions')
        .update({
          seats_used: newSeatsUsed,
          updated_at: new Date().toISOString()
        })
        .eq('id', subscription.id);
    }
  }

  return { success: true };
}

export async function createDocument<T extends Record<string, any>>(
  table: string,
  data: Omit<T, 'id' | 'created_at' | 'updated_at'>
): Promise<T> {
  const currentUser = await getCurrentUser();
  if (!currentUser) {
    throw new Error('Aucun utilisateur connecté');
  }

  if (!currentUser.agency_id && currentUser.email !== 'hosni@swipe-upp.com') {
    throw new Error('Aucune agence associée à cet utilisateur');
  }

  const docData = {
    ...data,
    agency_id: currentUser.agency_id || data.agency_id,
    created_by: currentUser.id,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  };

  if (table === 'influencers' || table === 'collabs') {
    if (currentUser.agency_id) {
      const { data: agencyData } = await supabase
        .from('agencies')
        .select('name')
        .eq('id', currentUser.agency_id)
        .maybeSingle();

      if (agencyData) {
        docData.agency_name = agencyData.name;
      }
    }
  }

  const { data: result, error } = await supabase
    .from(table)
    .insert(docData)
    .select()
    .single();

  if (error) throw error;
  return result as T;
}

export async function getDocuments<T>(table: string): Promise<T[]> {
  const currentUser = await getCurrentUser();
  if (!currentUser) {
    return [];
  }

  let query = supabase.from(table).select('*');

  if (table === 'todos') {
    if (currentUser.email === 'hosni@swipe-upp.com') {
      query = query.eq('user_id', currentUser.id);
    } else {
      query = query.or(`user_id.eq.${currentUser.id},assigned_to.eq.${currentUser.id}`);
    }
  } else if (currentUser.email !== 'hosni@swipe-upp.com') {
    if (currentUser.agency_id) {
      query = query.eq('agency_id', currentUser.agency_id);
    } else {
      return [];
    }
  }

  const { data, error } = await query;

  if (error) {
    console.error('Error getting documents:', error);
    return [];
  }

  return (data || []) as T[];
}

export async function getDocument<T>(table: string, id: string): Promise<T | null> {
  const { data, error } = await supabase
    .from(table)
    .select('*')
    .eq('id', id)
    .maybeSingle();

  if (error) {
    console.error('Error getting document:', error);
    return null;
  }

  return data as T | null;
}

export async function updateDocument<T>(
  table: string,
  id: string,
  data: Partial<T>
): Promise<T> {
  const currentUser = await getCurrentUser();
  if (!currentUser) {
    throw new Error('Aucun utilisateur connecté');
  }

  const updateData = {
    ...data,
    updated_at: new Date().toISOString(),
  };

  const { data: result, error } = await supabase
    .from(table)
    .update(updateData)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return result as T;
}

export async function deleteDocument(table: string, id: string): Promise<void> {
  const currentUser = await getCurrentUser();
  if (!currentUser) {
    throw new Error('Aucun utilisateur connecté');
  }

  const { error } = await supabase
    .from(table)
    .delete()
    .eq('id', id);

  if (error) throw error;
}

export async function deleteUserFromSupabase(userId: string): Promise<{ success: boolean; message?: string }> {
  const currentUser = await getCurrentUser();
  if (!currentUser) {
    throw new Error('Aucun utilisateur connecté');
  }

  const isSuperAdmin = currentUser.email === 'hosni@swipe-upp.com';
  const isAdmin = currentUser.user_role === 'admin';

  if (!isSuperAdmin && !isAdmin) {
    throw new Error('Vous n\'avez pas les droits pour supprimer un utilisateur');
  }

  const { data: userToDelete } = await supabase
    .from('users')
    .select('*')
    .eq('id', userId)
    .maybeSingle();

  if (!userToDelete) {
    throw new Error('L\'utilisateur à supprimer n\'existe pas');
  }

  if (!isSuperAdmin) {
    if (userToDelete.agency_id !== currentUser.agency_id) {
      throw new Error('Vous ne pouvez pas supprimer un utilisateur d\'une autre agence');
    }

    if (userToDelete.agency_id) {
      const { data: agency } = await supabase
        .from('agencies')
        .select('owner_id')
        .eq('id', userToDelete.agency_id)
        .maybeSingle();

      if (agency && agency.owner_id === userId) {
        throw new Error('Vous ne pouvez pas supprimer le propriétaire de l\'agence');
      }
    }
  }

  const { error } = await supabase
    .from('users')
    .delete()
    .eq('id', userId);

  if (error) throw error;

  if (userToDelete.agency_id) {
    const { data: subscription } = await supabase
      .from('subscriptions')
      .select('id, seats_used')
      .eq('agency_id', userToDelete.agency_id)
      .eq('status', 'active')
      .maybeSingle();

    if (subscription && subscription.seats_used > 0) {
      await supabase
        .from('subscriptions')
        .update({
          seats_used: subscription.seats_used - 1,
          updated_at: new Date().toISOString()
        })
        .eq('id', subscription.id);
    }
  }

  return { success: true, message: 'Utilisateur supprimé avec succès' };
}

export async function documentExists(table: string, id: string): Promise<boolean> {
  if (!id) return false;

  const { data } = await supabase
    .from(table)
    .select('id')
    .eq('id', id)
    .maybeSingle();

  return !!data;
}
